import { render, staticRenderFns } from "./Noticia.vue?vue&type=template&id=6f4cd766&scoped=true"
import script from "./Noticia.vue?vue&type=script&lang=js"
export * from "./Noticia.vue?vue&type=script&lang=js"
import style0 from "./Noticia.vue?vue&type=style&index=0&id=6f4cd766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4cd766",
  null
  
)

export default component.exports